import script from "./GroupOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupOffer.vue?vue&type=script&setup=true&lang=js"

import "./GroupOffer.vue?vue&type=style&index=0&id=9c920162&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c920162"]])

export default __exports__